import React from "react";
// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

import imag1 from "assets/images/poze-site/6-2-galerie-postconstruct.webp";
import imag2 from "assets/images/poze-site/6-6-galerie-postconstruct.webp";
import feedbackImg from "assets/images/poze-site/feedback-curatenie.jpg";

function ArticleContent() {
    return (
        <MKBox component="section" py={6}>
            <Container>
                <Grid container spacing={3} justifyContent="center">
                    <Grid item xs={12} lg={8}>
                        <MKTypography variant="h2" mb={3}>
                            De ce să alegi o firmă de curățenie după constructor pentru spațiul tău?
                        </MKTypography>
                        <MKBox
                            component="img"
                            src={imag1}
                            alt="curățenie după constructor"
                            width="100%"
                            borderRadius="lg"
                            mb={3}
                            boxShadow="md"
                        />
                        <MKTypography variant="body1" color="text" mb={2}>
                            Curățenia post-șantier necesită mult mai mult decât o simplă măturare
                            sau o ștergere superficială a prafului.
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={2}>
                            Este nevoie de o vastă experiență tehnică pentru a nu zgâria suprafețele
                            noi și de utilaje industriale capabile să extragă praful fin din cele
                            mai mici orificii sau pori ai materialelor.
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={2}>
                            Alegerea unor profesioniști garantează protejarea investiției masive
                            făcute în finisaje, deoarece utilizarea unor substanțe neadecvate poate
                            păta iremediabil marmura sau parchetul.
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={3}>
                            Conform studiilor privind calitatea aerului interior, praful de șantier
                            (care conține adesea silicați și particule de glet) poate persista luni
                            de zile dacă nu este extras prin metode de aspirare forțată și filtrare
                            HEPA.
                        </MKTypography>

                        <MKBox
                            component="img"
                            src={imag2}
                            alt="firmă de curățenie după constructor"
                            width="100%"
                            borderRadius="lg"
                            mt={2}
                            mb={3}
                            boxShadow="md"
                        />

                        <MKTypography variant="h2" mt={5} mb={2}>
                            Portofoliu de anvergură: Proiecte care ne recomandă
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={2}>
                            Proiectele de amploare realizate în ultimii ani ne-au consolidat poziția
                            în piața serviciilor de curățenie, plasându-ne printre cele mai
                            apreciate și de încredere firme din domeniu. Capacitatea noastră de a
                            gestiona suprafețe logistice și comerciale masive demonstrează rigoarea
                            proceselor noastre:
                        </MKTypography>
                        <MKBox component="ul" pl={4} mb={3}>
                            <MKTypography component="li" variant="body1" color="text">
                                <strong>Supernova Constanța / Dr. Turnu-Severin</strong>: Proiecte
                                industriale de 6.000 - 8.000 mp.
                            </MKTypography>
                            <MKTypography component="li" variant="body1" color="text">
                                <strong>Supernova Lujerului și Alexandriei</strong>: Intervenții la
                                fațade, colantări, travelatoare, pavaje și parcări.
                            </MKTypography>
                            <MKTypography component="li" variant="body1" color="text">
                                <strong>Clădirea The Mark</strong>: Curățenie detaliată pentru 8
                                etaje, suprafață de 8.000 mp.
                            </MKTypography>
                            <MKTypography component="li" variant="body1" color="text">
                                <strong>Clădirile SparkWare</strong>: Proiecte complexe pentru 9
                                etaje, depășind 12.500 mp.
                            </MKTypography>
                            <MKTypography component="li" variant="body1" color="text">
                                <strong>Clădirile Oregon Parc</strong>: Igienizare pentru 5 etaje,
                                suprafață de peste 16.500 mp.
                            </MKTypography>
                            <MKTypography component="li" variant="body1" color="text">
                                <strong>Clădirea Pridvorului Rezidence</strong>: Proiecte realizate
                                pe etape, suprafață de peste 6.000 mp.
                            </MKTypography>
                            <MKTypography component="li" variant="body1" color="text">
                                <strong>Complex Comercial Băneasa</strong>: Intervenții specifice
                                pentru mai multe magazine, peste 15.000 mp.
                            </MKTypography>
                            <MKTypography component="li" variant="body1" color="text">
                                <strong>
                                    Magazinele Mobexpert (Băneasa, Pipera, Pallady, Brașov)
                                </strong>
                                : Curățare și{" "}
                                <MKTypography
                                    component="a"
                                    href="/curatare-pardoseli"
                                    color="info"
                                    fontWeight="medium"
                                >
                                    tratamente speciale aplicate pardoselilor
                                </MKTypography>
                                , pe o suprafață de peste 35.000 mp.
                            </MKTypography>
                        </MKBox>

                        <MKTypography variant="h2" mt={5} mb={2}>
                            Ce include pachetul complet de curățenie după renovare sau construcție?
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={2}>
                            Serviciile noastre sunt exhaustive și acoperă fiecare detaliu, de la
                            plafon până la pardoseală. Ne concentrăm pe eliminarea atât a
                            reziduurilor grosiere cât și a celor fine, asigurându-ne că spațiul
                            trece prin{" "}
                            <MKTypography
                                component="a"
                                href="/curatenie-generala"
                                color="info"
                                fontWeight="medium"
                            >
                                procesele riguroase de curățenie generală
                            </MKTypography>{" "}
                            necesare înainte de mobilare. Iată principalele etape pe care le
                            parcurgem pentru rezultate sigure.
                        </MKTypography>
                        <MKTypography variant="h5" color="text" mb={2} mt={3}>
                            Etapele procesului de igienizare detaliată
                        </MKTypography>
                        <MKBox component="ul" pl={4} mb={3}>
                            <MKTypography component="li" variant="body1" color="text">
                                <strong>Îndepărtarea prafului fin și a reziduurilor</strong>:
                                Realizăm o aspirare industrială completă a pereților și pardoselilor
                                pentru a elimina praful de glet și ciment. Eliminăm resturile de
                                adezivi sau spumă poliuretanică rămase accidental.
                            </MKTypography>
                            <MKTypography component="li" variant="body1" color="text">
                                <strong>Curățarea urmelor de vopsea și ciment</strong>: Folosim
                                soluții decapante specifice pentru a îndepărta petele de var de pe
                                pardoseli și plinte, fără a afecta textura materialelor sensibile.
                            </MKTypography>
                            <MKTypography component="li" variant="body1" color="text">
                                <strong>Spălarea geamurilor și a tocăriilor</strong>: Curățăm
                                geamurile pe ambele fețe, eliminăm etichetele și foliile de
                                protecție de pe profile și insistăm pe curățarea garniturilor.
                            </MKTypography>
                            <MKTypography component="li" variant="body1" color="text">
                                <strong>Igienizarea băilor și bucătăriilor</strong>: Dezinfectăm
                                faianța și obiectele sanitare, eliminând resturile de chit dintre
                                rosturi și praful din interiorul corpurilor de mobilier montate.
                            </MKTypography>
                            <MKTypography component="li" variant="body1" color="text">
                                <strong>Curățarea locurilor greu accesibile</strong>: Nu omitem
                                grilele de ventilație, caloriferele, prizele sau balustradele,
                                asigurând o{" "}
                                <MKTypography
                                    component="a"
                                    href="/curatenie-vile-apartamente"
                                    color="info"
                                    fontWeight="medium"
                                >
                                    igienizare completă a vilelor sau apartamentelor
                                </MKTypography>{" "}
                                proaspăt renovate.
                            </MKTypography>
                            <MKTypography component="li" variant="body1" color="text">
                                <strong>Tratamente speciale pentru pardoseli</strong>: Aplicăm
                                spălarea mecanizată pentru suprafețele dure și oferim soluții de
                                lustruire sau ceruire pentru a sigila materialele noi.
                            </MKTypography>
                        </MKBox>

                        <MKTypography variant="h2" mt={5} mb={2}>
                            Preț curățenie după constructor, factorii care influențează costul
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={2}>
                            Prețul pe metru pătrat pentru curățenia după constructor depinde de
                            gradul de murdărie, suprafața totală și complexitatea finisajelor. O
                            locație care necesită doar o intervenție finală va avea costuri diferite
                            față de una unde trebuie realizată și evacuarea deșeurilor ușoare.
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={2}>
                            Indiferent de anvergură, oferim cotații transparente și adaptate
                            nevoilor tale, fie că este vorba de{" "}
                            <MKTypography
                                component="a"
                                href="/curatenie-vile-apartamente"
                                color="info"
                                fontWeight="medium"
                            >
                                reprospătarea unui apartament
                            </MKTypography>{" "}
                            sau de un sediu de companie.
                        </MKTypography>

                        <MKBox p={3} mb={3} mt={3} bgcolor="light.main" borderRadius="lg">
                            <MKTypography variant="h5" mb={1} color="info">
                                Cere o ofertă personalizată!
                            </MKTypography>
                            <MKTypography variant="body2" color="text">
                                Contactează-ne la telefon <strong>0730 407 322</strong>
                            </MKTypography>
                        </MKBox>

                        <MKTypography variant="h2" mt={5} mb={2}>
                            Feedback clienți
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={2}>
                            Recenziile primite de la partenerii noștri confirmă atenția noastră
                            pentru detalii și respectarea termenelor limită. Clienții apreciază în
                            special capacitatea noastră de a reda strălucirea finisajelor de lux
                            fără a lăsa urme de praf fin în aerul respirat.
                        </MKTypography>
                        <MKBox
                            component="img"
                            src={feedbackImg}
                            alt="feedback curatenie dupa constructor"
                            width="100%"
                            borderRadius="lg"
                            mb={3}
                            boxShadow="md"
                        />

                        <MKTypography variant="h2" mt={5} mb={2}>
                            Avantaj client: Organizare și eficiență
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={2}>
                            Doral Cleaning oferă servicii profesionale de curățenie, respectând
                            termenele stabilite și aplicând procese clare de lucru. Experiența
                            noastră arată că beneficiarii apelează frecvent la noi în etape
                            distincte:
                        </MKTypography>
                        <MKBox component="ol" pl={4} mb={3}>
                            <MKTypography component="li" variant="body1" color="text">
                                <strong>Curățenie grosieră</strong>: Realizată în timpul
                                construcției pentru degajarea spațiilor și prevenirea accidentelor
                                de muncă.
                            </MKTypography>
                            <MKTypography component="li" variant="body1" color="text">
                                <strong>Curățarea sub pardoseala flotantă</strong>: Efectuată
                                înainte de montarea mochetei sau a finisajelor finale.
                            </MKTypography>
                            <MKTypography component="li" variant="body1" color="text">
                                <strong>Curățenie post-constructor finală</strong>: Realizată
                                înainte de mobilare, incluzând tavane, fațade și grupuri sanitare.
                            </MKTypography>
                        </MKBox>
                        <MKTypography variant="body1" color="text" mb={3}>
                            În proiectele unde aceste etape nu au fost parcurse anterior, serviciul
                            devine o curățenie generală complexă care necesită timp suplimentar și o
                            atenție sporită la protejarea bunurilor deja aduse în spațiu.
                        </MKTypography>

                        <MKTypography variant="h2" mt={5} mb={2}>
                            Sfaturile noastre pentru protejarea investiției după lucrările de
                            renovare
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={1}>
                            Alegeți o firmă de curățenie specializată, care verifică și testează
                            suprafețele înainte de intervenție.
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={1}>
                            Îndepărtarea murdăriei post-șantier fără echipamente dedicate poate duce
                            la deteriorarea iremediabilă a suprafețelor prin zgâriere sau pătare
                            chimică.
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={1}>
                            Pentru a reduce costurile finale, vă recomandăm să protejați pardoselile
                            cu folie groasă și suport textil pe parcursul lucrărilor de renovare.
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={3}>
                            Dă-ți jos foliile de protecție de pe geamuri cât mai repede posibil.
                            Dacă rămân prea mult atașate se lipesc și devin dificil de dezlipit.
                        </MKTypography>

                        <MKBox p={3} mb={3} mt={3} bgcolor="light.main" borderRadius="lg">
                            <MKTypography variant="h5" mb={1} color="info">
                                Cere o oferta personalizată!
                            </MKTypography>
                            <MKTypography variant="body2" color="text">
                                Fiecare spațiu are nevoi diferite. Nu te mulțumi cu soluții
                                standard. Cere o ofertă personalizată astăzi și hai să discutăm
                                concret despre proiectul tău!
                                <br />
                                <br />
                                Contactează-ne la telefon <strong>0730 407 322</strong>
                            </MKTypography>
                        </MKBox>

                        <MKTypography variant="h2" mt={5} mb={2}>
                            Unde lucrăm: în toate sectoarele Bucureștiului și în Ilfov
                        </MKTypography>
                        <MKTypography variant="body1" color="text" mb={3}>
                            Sediul Doral Cleaning este pe Calea Șerban Vodă 82, în Sectorul 4, între
                            Unirii și Tineretului. De aici pleacă echipele noastre către clienții din
                            toate cele șase sectoare ale Bucureștiului și din Ilfov: Voluntari,
                            Pantelimon, Popești-Leordeni, Bragadiru, Măgurele, Chitila, Buftea și
                            Otopeni. Deplasarea pentru evaluarea spațiului este gratuită în București
                            și în Ilfov (iar pentru intervențiile efective de curățenie, tariful
                            minim / deplasarea este de 500 lei). Intervenim atât în apartamentele și
                            vilele din București, cât și în casele și ansamblurile noi din
                            localitățile din Ilfov.
                        </MKTypography>

                        <MKTypography variant="h3" mt={5} mb={2}>
                            Întrebări frecvente
                        </MKTypography>
                        <MKTypography variant="h6" mt={2}>
                            Lucrați și în afara Sectorului 4?
                        </MKTypography>
                        <MKTypography variant="body2" color="text" mb={2}>
                            Da. Sediul nostru este în Sectorul 4, dar lucrăm în toate sectoarele
                            Bucureștiului și în Ilfov, inclusiv în Voluntari, Pantelimon,
                            Popești-Leordeni, Bragadiru, Măgurele, Chitila, Buftea și Otopeni.
                            Deplasarea pentru evaluare este gratuită.
                        </MKTypography>

                        <MKTypography variant="h6" mt={2}>
                            Este serviciul de curățare după constructor sigur pentru suprafețele
                            sensibile?
                        </MKTypography>
                        <MKTypography variant="body2" color="text" mb={2}>
                            Da, folosim exclusiv substanțe cu pH neutru și unelte care nu zgârie. Ne
                            asigurăm că parchetul, marmura sau finisajele de lux sunt protejate pe
                            tot parcursul intervenției prin{" "}
                            <MKTypography
                                component="a"
                                href="/curatare-pardoseli"
                                color="info"
                                fontWeight="medium"
                            >
                                tehnici de spălare specifice fiecărui material
                            </MKTypography>
                            .
                        </MKTypography>

                        <MKTypography variant="h6" mt={2}>
                            Cât durează în medie curățenia după renovare?
                        </MKTypography>
                        <MKTypography variant="body2" color="text" mb={2}>
                            Durata depinde de mărimea spațiului, însă de obicei finalizăm un
                            apartament într-o singură zi datorită echipei numeroase și a utilajelor
                            care accelerează procesul de aspirare și spălare.
                        </MKTypography>

                        <MKTypography variant="h6" mt={2}>
                            Pot fi eliminate complet urmele de ciment sau adeziv uscat?
                        </MKTypography>
                        <MKTypography variant="body2" color="text" mb={2}>
                            Echipele noastre folosesc aparate cu abur și soluții decapante
                            profesionale care dizolvă reziduurile de ciment și chit fără a deteriora
                            suprafața de dedesubt.
                        </MKTypography>

                        <MKTypography variant="h6" mt={2}>
                            Lucrați și în weekend sau în afara programului standard?
                        </MKTypography>
                        <MKTypography variant="body2" color="text" mb={2}>
                            Suntem flexibili și ne adaptăm programului tău pentru a nu întârzia
                            mutarea, oferind posibilitatea intervențiilor în afara orelor obișnuite
                            de lucru dacă situația o impune.
                        </MKTypography>

                        <MKTypography variant="h6" mt={2}>
                            Includeți și colectarea deșeurilor de șantier?
                        </MKTypography>
                        <MKTypography variant="body2" color="text" mb={2}>
                            Ne ocupăm de colectarea deșeurilor ușoare rezultate în urma curățeniei
                            și evacuarea acestora, lăsând spațiul aerisit, odorizat și gata de
                            utilizare imediată.
                        </MKTypography>

                        <script
                            type="application/ld+json"
                            dangerouslySetInnerHTML={{
                                __html: JSON.stringify({
                                    "@context": "https://schema.org",
                                    "@type": "FAQPage",
                                    mainEntity: [
                                        {
                                            "@type": "Question",
                                            name: "Lucrați și în afara Sectorului 4?",
                                            acceptedAnswer: {
                                                "@type": "Answer",
                                                text: "Da. Sediul nostru este în Sectorul 4, dar lucrăm în toate sectoarele Bucureștiului și în Ilfov, inclusiv în Voluntari, Pantelimon, Popești-Leordeni, Bragadiru, Măgurele, Chitila, Buftea și Otopeni. Deplasarea pentru evaluare este gratuită.",
                                            },
                                        },
                                        {
                                            "@type": "Question",
                                            name: "Este serviciul de curățare după constructor sigur pentru suprafețele sensibile?",
                                            acceptedAnswer: {
                                                "@type": "Answer",
                                                text: "Da, folosim exclusiv substanțe cu pH neutru și unelte care nu zgârie. Ne asigurăm că parchetul, marmura sau finisajele de lux sunt protejate pe tot parcursul intervenției prin tehnici de spălare specifice fiecărui material.",
                                            },
                                        },
                                        {
                                            "@type": "Question",
                                            name: "Cât durează în medie curățenia după renovare?",
                                            acceptedAnswer: {
                                                "@type": "Answer",
                                                text: "Durata depinde de mărimea spațiului, însă de obicei finalizăm un apartament într-o singură zi datorită echipei numeroase și a utilajelor care accelerează procesul de aspirare și spălare.",
                                            },
                                        },
                                        {
                                            "@type": "Question",
                                            name: "Pot fi eliminate complet urmele de ciment sau adeziv uscat?",
                                            acceptedAnswer: {
                                                "@type": "Answer",
                                                text: "Echipele noastre folosesc aparate cu abur și soluții decapante profesionale care dizolvă reziduurile de ciment și chit fără a deteriora suprafața de dedesubt.",
                                            },
                                        },
                                        {
                                            "@type": "Question",
                                            name: "Lucrați și în weekend sau în afara programului standard?",
                                            acceptedAnswer: {
                                                "@type": "Answer",
                                                text: "Suntem flexibili și ne adaptăm programului tău pentru a nu întârzia mutarea, oferind posibilitatea intervențiilor în afara orelor obișnuite de lucru dacă situația o impune.",
                                            },
                                        },
                                        {
                                            "@type": "Question",
                                            name: "Includeți și colectarea deșeurilor de șantier?",
                                            acceptedAnswer: {
                                                "@type": "Answer",
                                                text: "Ne ocupăm de colectarea deșeurilor ușoare rezultate în urma curățeniei și evacuarea acestora, lăsând spațiul aerisit, odorizat și gata de utilizare imediată.",
                                            },
                                        },
                                    ],
                                }),
                            }}
                        />
                    </Grid>
                </Grid>
            </Container>
        </MKBox>
    );
}

export default ArticleContent;
